import clone from 'lodash/clone'

import {
    ADD_MESSAGE,
    ADD_FIREWALLD,
    SWAP_DIV,
} from '../actions/actions'

// Lets try some fancy datastructures
var CircularBuffer = require('circular-buffer')
var messages_cbuf = new CircularBuffer(10)
var firewalld_cbuf = new CircularBuffer(10)

const initialState = {
    messages: messages_cbuf,
    firewalld: firewalld_cbuf,
    settings: {
        swappablediv: true 
    }
}

export function settings(state = initialState.settings, action) {
    let newState = JSON.parse( JSON.stringify(state) )
    switch(action.type) {
        case SWAP_DIV:
            newState.swappablediv = !newState.swappablediv
            return newState
            break
        default:
            return state
    }
}

export function messages(state = initialState.messages, action) {
    switch (action.type) {
        case ADD_MESSAGE:
            // We have to create a new cbuf
            let new_cbuf = new CircularBuffer(10)
            if (state.size() == 10) return new_cbuf
            state.toarray().map( function(i) {
                new_cbuf.push(i)
            })
            new_cbuf.push(action.payload)
            return new_cbuf


            /*const { payload } = action
            return {
                ...state,
                messages: state.messages.enq(payload)
            }*/

        default:
            return state
    }
}

export function firewalld(state = initialState.firewalld, action) {
    switch (action.type) {
        case ADD_FIREWALLD:
            let new_cbuf = new CircularBuffer(10)
            state.toarray().map( function(i) {
                new_cbuf.push(i)
            })
            new_cbuf.push(action.payload)
            return new_cbuf
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/reducers/reducers.js